import { NewMarketplaceListingQuery } from './__generated__/NewMarketplaceListingQuery'
import { gql } from 'apollo-boost'
import { useQuery } from '@apollo/react-hooks'

const QUERY = gql`
  query NewMarketplaceListingQuery {
    publicInstallables {
      id
      public
      created
      acceptsMessageSets
      developer {
        id
        title
      }
      title
    }
  }
`

export const useNewMarketplaceListingQuery = () =>
  useQuery<NewMarketplaceListingQuery>(QUERY, { fetchPolicy: 'network-only' })
